import React from "react";

interface CardSkeletonProps {
  rows?: number;
}

const CardSkeleton: React.FC<CardSkeletonProps> = ({ rows = 5 }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: rows }).map((_, idx) => (
        <div
          key={idx}
          className="rounded-2xl bg-white border border-gray-200 p-2 shadow-sm animate-pulse flex justify-between items-center w-full"
        >
          <div className="space-y-3 flex-1">
            <div className="flex items-center gap-3">
              <div className="h-6 w-40 bg-gray-200 rounded-lg" />

              <div className="h-7 w-24 bg-indigo-100 rounded-md" />

              <div className="h-7 w-28 bg-amber-100 rounded-md" />
            </div>
            <div className="space-y-2">
              <div className="h-4 w-[300px] bg-gray-200 rounded" />
              <div className="h-4 w-[200px] bg-gray-200 rounded" />
            </div>

            <div className="flex items-center gap-6">
              <div className="h-4 w-40 bg-gray-200 rounded" />
              <div className="h-4 w-32 bg-gray-200 rounded" />
            </div>
          </div>

          <div className="flex items-center gap-4 ">
            <div className="text-right space-y-2">
              <div className="h-3 w-12 bg-gray-200 rounded ml-auto" />
              <div className="h-4 w-20 bg-gray-200 rounded ml-auto" />
            </div>

            <div className="flex gap-2">
              <div className="w-8 h-8 rounded-xl bg-gray-200" />
              <div className="w-8 h-8 rounded-xl bg-gray-200" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardSkeleton;
